import { render, staticRenderFns } from "./DashboardCommunicationTab.vue?vue&type=template&id=a4e8c434&scoped=true"
import script from "./DashboardCommunicationTab.vue?vue&type=script&lang=js"
export * from "./DashboardCommunicationTab.vue?vue&type=script&lang=js"
import style0 from "./DashboardCommunicationTab.vue?vue&type=style&index=0&id=a4e8c434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e8c434",
  null
  
)

export default component.exports